import type { FormField } from '../../../types';

export function getFormFieldValue(field: FormField | undefined): string | null {
  const value = field?.value?.trim();
  return value ? value : null;
}

export function pushFormFieldValue(
  parameterNames: string[],
  field: FormField | undefined,
): void {
  const value = getFormFieldValue(field);
  if (value) {
    parameterNames.push(value);
  }
}
